// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"302507e8","404":"aec334db","498":"80e2dfd9","513":"8af12b42","545":"aef9dd46","787":"944420bb"}[chunkId] + ".chunk.js";
};